export function ajustadorVideo(video) {
    let iframe = video.querySelector("iframe, object");
    if(iframe) {
        let positionInfo  = video.getBoundingClientRect()
        let ancho = positionInfo.width;
        let anchoVideo = parseInt(iframe.getAttribute("width"));
        let altoVideo = parseInt(iframe.getAttribute("height"));
        let ra = 16/9;
        if (anchoVideo && altoVideo) {
            ra = anchoVideo/altoVideo;
        }
        iframe.setAttribute("width", "" + ancho);
        iframe.setAttribute("height", "" + (ancho/ra));
    }
}
